function initRad(root = document) {
  root.querySelectorAll('[data-rad-finder]').forEach(form => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    const section = form.closest('section');
    const results = section.querySelector('[data-rad-results]');
    const options = [...results.querySelectorAll('[data-rad-option]')];
    form.addEventListener('submit', event => {
      event.preventDefault();
      const trans = form.elements.transmission.value;
      let count = 0;
      options.forEach(option => {
        const matches = option.dataset.transmissions.split(',').map(s => s.trim()).includes(trans);
        option.hidden = !matches;
        if (matches) count++;
      });
      results.querySelector('[data-rad-no-match]').hidden = count > 0;
      results.hidden = false;
      results.focus({ preventScroll: true });
      results.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    });
  });
  root.querySelectorAll('.rad-mobile-menu').forEach(menu => {
    if (menu.dataset.ready) return;
    menu.dataset.ready = 'true';
    menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => { menu.open = false; }));
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
  });
}
window.onSubmitRadAccessoryForm = async (form, event) => {
  event.preventDefault();
  event.stopPropagation();
  if (form.dataset.submitting) return;
  form.dataset.submitting = 'true';
  const button = form.querySelector('[name="add"]');
  const status = form.querySelector('[data-accessory-status]');
  const cartLink = form.querySelector('[data-accessory-cart-link]');
  button.disabled = true;
  form.setAttribute('aria-busy', 'true');
  status.hidden = false;
  status.textContent = status.dataset.adding;
  status.dataset.state = 'loading';
  cartLink.hidden = true;
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST', body: new FormData(form), credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || error.message || status.dataset.error);
    }
    status.textContent = status.dataset.added;
    status.dataset.state = 'success';
    cartLink.hidden = false;
    try {
      if (typeof window.refreshCartContents === 'function') await window.refreshCartContents(response);
      const drawer = document.querySelector('#offcanvas-cart');
      if (drawer && window.bootstrap?.Offcanvas) window.bootstrap.Offcanvas.getOrCreateInstance(drawer).show();
    } catch (_) { /* The confirmed addition remains visible with a link to the cart. */ }
  } catch (error) {
    status.textContent = error.message || status.dataset.error;
    status.dataset.state = 'error';
  } finally {
    button.disabled = false;
    form.removeAttribute('aria-busy');
    delete form.dataset.submitting;
  }
};
document.addEventListener('DOMContentLoaded', () => initRad());
document.addEventListener('shopify:section:load', event => initRad(event.target));
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    const path = (window.Shopify?.routes?.root || '/') + 'cart.js';
    fetch(path, { credentials: 'same-origin' }).then(r => r.json()).then(cart => document.querySelectorAll('[data-rad-cart-count]').forEach(el => { el.textContent = cart.item_count; })).catch(() => {});
  }
});
